import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeSection() {
  const { accent, setAccent, PRESETS } = useTheme();
  const [custom, setCustom] = useState(accent);

  const s = {
    wrap: { padding: '32px 0' },
    title: { color: '#F0F0F0', fontSize: 22, fontWeight: 700, marginBottom: 4 },
    sub: { color: '#888', fontSize: 14, marginBottom: 32 },
    block: { background: '#111', borderRadius: 14, padding: '28px 28px', marginBottom: 24 },
    blockTitle: { color: '#888', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 18 },
    swatchRow: { display: 'flex', gap: 14, flexWrap: 'wrap' },
    swatch: (hex) => ({
      width: 52, height: 52, borderRadius: 12,
      background: hex, cursor: 'pointer', border: 'none', flexShrink: 0,
      boxShadow: accent === hex ? `0 0 0 3px #111, 0 0 0 5px ${hex}` : 'none',
      transition: 'box-shadow .15s',
    }),
    swatchLabel: { color: '#888', fontSize: 11, marginTop: 6, textAlign: 'center' },
    swatchWrap: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    row: { display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' },
    colorInput: {
      width: 52, height: 52, borderRadius: 12, border: 'none', cursor: 'pointer',
      background: 'none', padding: 0,
    },
    hexInput: {
      background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: 10,
      color: '#F0F0F0', padding: '10px 14px', fontSize: 14, width: 120,
      outline: 'none', fontFamily: 'monospace',
    },
    applyBtn: {
      background: accent, color: '#080808', border: 'none', borderRadius: 10,
      padding: '10px 22px', fontSize: 14, fontWeight: 700, cursor: 'pointer',
    },
    preview: { marginTop: 32 },
    previewTitle: { color: '#F0F0F0', fontSize: 22, fontWeight: 700, marginBottom: 4 },
    previewBlock: { background: '#111', borderRadius: 14, padding: 28, marginTop: 0 },
    previewStat: (a) => ({
      display: 'inline-flex', flexDirection: 'column', background: '#1a1a1a',
      borderRadius: 12, padding: '18px 24px', marginRight: 16, marginBottom: 12,
      borderLeft: `3px solid ${a}`,
    }),
    previewStatNum: (a) => ({ color: a, fontSize: 28, fontWeight: 800 }),
    previewStatLabel: { color: '#888', fontSize: 12, marginTop: 2 },
    previewBtn: (a) => ({
      background: a, color: '#080808', border: 'none', borderRadius: 10,
      padding: '10px 22px', fontSize: 14, fontWeight: 700, cursor: 'default', marginRight: 12,
    }),
    previewBadge: (a) => ({
      background: a + '22', color: a, border: `1px solid ${a}44`,
      borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 600,
    }),
  };

  const NAMES = { lime: 'Lime', cyan: 'Cyan', purple: 'Violet', orange: 'Orange', pink: 'Rose', blue: 'Bleu' };

  const handleCustomApply = () => {
    if (/^#[0-9a-fA-F]{6}$/.test(custom)) {
      setAccent(custom);
    }
  };

  const handleColorPick = (e) => {
    setCustom(e.target.value);
    setAccent(e.target.value);
  };

  return (
    <div style={s.wrap}>
      <div style={s.title}>Personnalisation du thème</div>
      <div style={s.sub}>Choisissez une couleur d'accent pour votre dashboard. Le changement est instantané.</div>

      <div style={s.block}>
        <div style={s.blockTitle}>Thèmes prédéfinis</div>
        <div style={s.swatchRow}>
          {Object.entries(PRESETS).map(([key, hex]) => (
            <div key={key} style={s.swatchWrap}>
              <button style={s.swatch(hex)} onClick={() => setAccent(hex)} title={NAMES[key]} />
              <div style={s.swatchLabel}>{NAMES[key]}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={s.block}>
        <div style={s.blockTitle}>Couleur personnalisée</div>
        <div style={s.row}>
          <input
            type="color"
            value={custom}
            onChange={handleColorPick}
            style={s.colorInput}
            title="Choisir une couleur"
          />
          <input
            type="text"
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            placeholder="#C8FF00"
            style={s.hexInput}
            maxLength={7}
            spellCheck={false}
          />
          <button style={s.applyBtn} onClick={handleCustomApply}>Appliquer</button>
        </div>
      </div>

      <div style={s.block}>
        <div style={s.blockTitle}>Aperçu</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 20 }}>
          <div style={s.previewStat(accent)}>
            <span style={s.previewStatNum(accent)}>24</span>
            <span style={s.previewStatLabel}>Clients actifs</span>
          </div>
          <div style={s.previewStat(accent)}>
            <span style={s.previewStatNum(accent)}>8</span>
            <span style={s.previewStatLabel}>Projets en cours</span>
          </div>
          <div style={s.previewStat(accent)}>
            <span style={s.previewStatNum(accent)}>$12,400</span>
            <span style={s.previewStatLabel}>Revenus ce mois</span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <button style={s.previewBtn(accent)}>Nouveau client</button>
          <span style={s.previewBadge(accent)}>Actif</span>
          <span style={{ color: accent, fontSize: 14, fontWeight: 600 }}>Lien actif</span>
        </div>
      </div>
    </div>
  );
}
